// extracted by mini-css-extract-plugin
module.exports = {"pageLoading":"PageLoading_pageLoading__1Lz7D"};